import operations from '~/helpers/device-operations';
import { Camera } from './camera.model';

export class NACamera extends Camera {

    minimumRebootFirmware = 210;
    minimumUnlockFirmware = 460;
    minimumHomekitResetFirmware = 5014000;

    get deviceOperations() {
        return super.deviceOperations.concat([
            operations.associateUser({ disabled: this.associateUserDisabled }),
            operations.homekitReset({ callback: this.homekitReset, disabled: this.isHomekitResetDisabled })
        ]);
    }

    getWifiChipAndShieldConfig() {
        // Wifi Chip & Shield condition :
        // MAC up to 70:EE:50:13:80:00 => AP6210 (not reliable)  + No shield
        // Mac between 70:EE:50:13:80:00 & 70:EE:50:14:25:25 => AP6210 + No shield
        // Mac betwenn 70:EE:50:14:25:25 & 70:EE:50:1d:87:fb => AP6212 + No shield
        // Mac between 70:EE:50:1d:87:fb & 70:EE:50:5d:87:f5 => AP6212 + Shield
        // Mac > 70:EE:50:5d:87:f5 =>  AP6212 (double LDO) + Shield

        const convertHexa = parseInt(this.id.replace(/:/g, ''), 16);

        if (convertHexa < parseInt('70EE50138000', 16)) {// 70:EE:50:13:80:00
            return {
                chip: 'AP6210 (not reliable)',
                shield: false,
            };
        } else if (convertHexa < parseInt('70EE50142525', 16)) { // between 70:EE:50:13:80:00 & 70:EE:50:14:25:25
            return {
                chip: 'AP6210',
                shield: false,
            };
        } else if (convertHexa < parseInt('70EE501D87FB', 16)) {// betwenn 70:EE:50:14:25:25 & 70:EE:50:1d:87:fb
            return {
                chip: 'AP6212',
                shield: false,
            };
        } else if (convertHexa < parseInt('70EE505D87F5', 16)) {// between 70:EE:50:1d:87:fb & 70:EE:50:5d:87:f5
            return {
                chip: 'AP6212',
                shield: true,
            };
        } else { // > 70:EE:50:5d:87:f5
            return {
                chip: 'AP6212 (double LDO)',
                shield: true,
            };
        }
    }
}
